import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Generate or retrieve a persistent session ID
const getSessionId = () => {
  let sid = sessionStorage.getItem("zeel_sid");
  if (!sid) {
    sid = "s_" + Math.random().toString(36).substr(2, 12) + Date.now().toString(36);
    sessionStorage.setItem("zeel_sid", sid);
  }
  return sid;
};

const track = (eventType, productId = null, metadata = {}) => {
  axios.post(`${API}/analytics/track`, {
    event_type: eventType,
    product_id: productId,
    metadata,
    session_id: getSessionId(),
  }).catch(() => {}); // fire-and-forget
};

// Track page view
export const trackPageView = (pageName) => track("page_view", null, { page: pageName });

// Track product view
export const trackProductView = (productId) => track("product_view", productId);

// Track social share
export const trackShare = (productId, platform) => track("share", productId, { platform });

// Track vote
export const trackVote = (productId, claimId) => track("vote_cast", productId, { claim_id: claimId });

// Track bookmark
export const trackBookmark = (productId) => track("bookmark", productId);

// Track signup
export const trackSignup = () => track("signup");

// Track affiliate/outbound click (Amazon, Nykaa)
export const trackAffiliateClick = (productId, platform) => track("affiliate_click", productId, { platform });

// Track video upload
export const trackVideoUpload = (productId) => track("video_upload", productId);

// Track time spent — call on page unload
let pageEntryTime = Date.now();

export const resetPageTimer = () => {
  pageEntryTime = Date.now();
};

export const trackTimeSpent = () => {
  const seconds = Math.round((Date.now() - pageEntryTime) / 1000);
  if (seconds > 2 && seconds < 3600) {
    // Use sendBeacon for reliability on page unload
    const data = JSON.stringify({
      event_type: "time_spent",
      metadata: { seconds },
      session_id: getSessionId(),
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/track`, new Blob([data], { type: "application/json" }));
    } else {
      track("time_spent", null, { seconds });
    }
  }
};
